import React from 'react';
import { Container, Grid, Box } from '@mui/material';
import { Link } from 'react-router-dom';
import loginLogo from '../../assets/svg/new-logo-with-title-white.svg';
import LoginForm from './LoginForm';
import { useFormStyles } from './authStyles';
import routes from '../../routes';
import SocialMediaLinkIcons from '../../components/SocialMediaLinkIcons';

const LoginPage = () => {
  const authStyles = useFormStyles();
  return (
    <Box sx={authStyles.pageBackground}>
      <Container maxWidth="md">
        <Grid container spacing={2} sx={authStyles.pageContainer} data-testid="login-container">
          <Grid item xs sx={authStyles.logoWrapper}>
            <Box component="img" src={loginLogo} alt="logo" sx={authStyles.logo} />
          </Grid>
          <Grid item xs sx={authStyles.loginFormWrapper}>
            <LoginForm />

            <Grid
              container
              sx={(theme) => ({
                [theme.breakpoints.down('sm')]: {
                  flexDirection: 'column',
                  gap: 1,
                  marginTop: 1,
                },
              })}
            >
              <Grid item xs>
                <Link to={routes.forgotPassword} variant="body2" style={{ color: '#fff' }}>
                  Forgot password?
                </Link>
              </Grid>

              <Grid item>
                <Link to={routes.signup} variant="body2" style={{ color: '#fff' }}>
                  Don't have an account? Sign Up
                </Link>
              </Grid>
            </Grid>

            <Grid container direction="row" justifyContent="center" alignItems="center" sx={{ paddingTop: 2 }}>
              <SocialMediaLinkIcons iconColor="#fff" />
            </Grid>

            <Grid container direction="row" justify="center" alignItems="center" style={{ marginTop: 8 }}>
              <a
                href="https://app.foodrescue.us/terms-of-service/rescuer"
                target="_blank"
                rel="noopener noreferrer"
                style={{ color: '#fff' }}
              >
                Terms of Service &amp; Privacy Policy
              </a>
            </Grid>
          </Grid>
        </Grid>
      </Container>
    </Box>
  );
};

export default LoginPage;
